import { useRef, useState } from 'react'
import { MoreVertical } from 'lucide-react'
import { FileExplorerItem } from '@features/file-explorer/types'
import ActionMenuItems from './ActionMenuItems'

interface ItemActionsMenuProps {
  item: FileExplorerItem
  onDelete: (item: FileExplorerItem) => void
  onRename: (item: FileExplorerItem) => void
  onDownload: (item: FileExplorerItem) => void
  onShow: (item: FileExplorerItem) => void
  onManagePermissions: (item: FileExplorerItem) => void
}

export default function ItemActionsMenu({
  item,
  onDelete,
  onRename,
  onDownload,
  onShow,
  onManagePermissions
}: ItemActionsMenuProps) {
  const triggerRef = useRef<HTMLDivElement>(null)
  // Lazy render: only create menu items after first click
  const [hasBeenOpened, setHasBeenOpened] = useState(false)

  const handleActionClick = () => {
    // Close the dropdown
    const elem = document.activeElement as HTMLElement
    elem?.blur()
  }

  return (
    <div className="dropdown dropdown-end" onClick={(e) => e.stopPropagation()}>
      <div
        ref={triggerRef}
        tabIndex={0}
        role="button"
        className="btn btn-ghost btn-sm btn-circle"
        onFocus={() => setHasBeenOpened(true)}
      >
        <MoreVertical className="w-4 h-4" />
      </div>
      {hasBeenOpened && (
        <ul
          tabIndex={-1}
          className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-1 w-52 p-2 shadow-lg border border-base-300"
        >
          <ActionMenuItems
            item={item}
            onDelete={onDelete}
            onRename={onRename}
            onDownload={onDownload}
            onShow={onShow}
            onManagePermissions={onManagePermissions}
            onActionClick={handleActionClick}
          />
        </ul>
      )}
    </div>
  )
}
